module.exports = __webpack_public_path__ + "img/kita_yes.bbff5665.png";